import { TV_SHOW_CONSUMPTION_STORIES_API_URL } from 'src/utils/constants/ApiConstants';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';

// Fetches stories for a given ID from the TV show consumption stories API.

export const fetchStories = async (id: string) => {
  const url = `${TV_SHOW_CONSUMPTION_STORIES_API_URL}/${id}`;
  try {
    const response = await fetch(url, {
      method: HTTP_METHODS.GET
    });
    const data = await response.json();
    // Perform a null check for the data object
    if (data && Object.keys(data).length) {
      return data?.posts;
    }
    return {};
  } catch (error) {
    // Handle the error and optionally rethrow it
    console.error('An error occurred:', error);
    return {};
  }
};
